import {
  Component,
  ChangeDetectionStrategy,
  AfterContentInit,
  ContentChildren,
  QueryList,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { DestroyableBase } from '../../utils';
import { TabViewTitleDirective } from './tab-view.directive';
import { TabViewViewModel } from './tab-view.view-model';

@Component({
  selector: 'osn-shared-tab-view',
  templateUrl: './tab-view.component.html',
  styleUrls: ['./tab-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabViewComponent extends DestroyableBase implements OnInit, AfterContentInit {
  @Output() public tabChange = new EventEmitter<MatTabChangeEvent>();
  @ContentChildren(TabViewTitleDirective) public templateChildren: QueryList<TabViewTitleDirective>;
  public template$ = new BehaviorSubject<TabViewViewModel[]>(undefined);
  public currentLanguage: string;

  constructor(private readonly translateService: TranslateService) {
    super();
  }

  public ngOnInit(): void {
    this.currentLanguage = this.translateService.currentLang;

    this.translateService.onLangChange.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
      this.currentLanguage = this.translateService.currentLang;
    });
  }

  public ngAfterContentInit() {
    this.updateTabs();
  }

  public getDataTestId(templateData: TabViewViewModel): string {
    return `DetailsPage.matTabLabel_${templateData.title?.replace(/ /g, '')}`;
  }

  public onTabChange(event: MatTabChangeEvent): void {
    this.tabChange.emit(event);
  }

  private updateTabs(): void {
    const templateChildren = this.templateChildren.toArray();
    this.template$.next(templateChildren.map((t) => ({ title: t.title, templateRef: t.templateRef })));
  }
}
